module.exports = __webpack_public_path__ + "img/japanese-“secret”-button.71d94480.png";